<template>
  <section class="testimonials-section">
    <div class="container">
      <span class="section-tag">TESTIMONIALS</span>
      <h2 class="section-title">What Our Clients Say</h2>
      <p class="section-subtitle">
        Real stories from homeowners and investors who found their perfect
        property with Clients Preferred Property Hub.
      </p>

      <div class="testimonials-grid">
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          class="testimonial-card"
        >
          <div class="quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"
              />
            </svg>
          </div>

          <div class="content-wrapper">
            <p class="review-text">"{{ testimonial.text }}"</p>

            <div class="highlights" v-if="testimonial.highlights">
              <span
                v-for="tag in testimonial.highlights"
                :key="tag"
                class="tag"
              >
                {{ tag }}
              </span>
            </div>
          </div>

          <div class="client-info">
            <div class="client-avatar">
              {{ testimonial.name.charAt(0) }}
            </div>
            <div class="client-details">
              <h4>{{ testimonial.name }}</h4>
              <p class="verified">Verified Client</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const testimonials = [
  {
    name: 'Raj',
    text: 'I had a very positive experience throughout my property purchase. I received a genuine deal with an excellent discount, which made the investment even more worthwhile. The team was extremely supportive in assisting me with the home loan process, guiding me at every step and ensuring everything was handled smoothly. What I appreciated the most was their commitment and dedication—they stood by me from the initial booking all the way through to the final delivery of my flat. Their professionalism, transparency, and consistent support made the entire journey stress-free and satisfying.',
    highlights: ['Home Loan Support', 'Genuine Deal', 'Full Delivery Support'],
  },
  {
    name: 'Vikas',
    text: 'My budget for a 2BHK was around 25 lakhs, and I was quite particular about finding a property that met both my financial limits and quality expectations. They patiently understood my needs and showed me a well-planned 2BHK flat located on the Kharar–Kurali Road in a gated society, which perfectly matched my expectations. I received a genuine deal with a good discount, and the team also extended full support in processing my home loan. Their honesty and dedication made my home-buying journey smooth and stress-free.',
    highlights: ['Budget Friendly', 'Gated Society', 'Transparent Guidance'],
  },
  {
    name: 'Vikram',
    text: 'I was looking for a property around ₹1.30 Cr for investment and residential purposes. Traveling from Bangalore to Chandigarh, I met the team at Clients Preferred. They were extremely professional and educated me about potential fraud risks in certain areas. They presented me with villas in a RERA-approved gated society, explaining the infrastructure and future growth prospects. After reviewing everything, I finalized the decision. I truly appreciate their transparency, market knowledge, and end-to-end support.',
    highlights: ['Investment Expert', 'RERA Approved', 'Outstation Support'],
  },
];
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.testimonials-section {
  padding: 100px 0;
  background: #ffffff;
  text-align: center;
}

.section-tag {
  color: #b91c1c;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 0.9rem;
}

.section-title {
  font-size: 2.5rem;
  margin: 10px 0 15px;
  color: #111;
  font-weight: 800;
}

.section-subtitle {
  color: #666;
  max-width: 700px;
  margin: 0 auto 60px;
  line-height: 1.6;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  text-align: left;
}

.testimonial-card {
  background: #f3f3f3;
  padding: 40px;
  border-radius: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  border: 1px solid #0a0a0a11;
}

.testimonial-card:hover {
  transform: translateY(-5px);
  background: #fff;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.05);
  border-color: #b91c1c33;
}

.quote-icon {
  color: #b91c1c;
  opacity: 0.15;
  margin-bottom: 20px;
}

.content-wrapper {
  flex-grow: 1;
}

.review-text {
  font-size: 1rem;
  color: #374151;
  line-height: 1.7;
  font-style: italic;
  margin-bottom: 25px;
}

.highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
}

.tag {
  background: #fff;
  color: #b91c1c;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 100px;
  border: 1px solid #b91c1c22;
  text-transform: uppercase;
}

.client-info {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-top: 25px;
  border-top: 1px solid #e5e7eb;
}

.client-avatar {
  width: 50px;
  height: 50px;
  background: #b91c1c;
  color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.2rem;
}

.client-details h4 {
  margin: 0;
  color: #111;
  font-size: 1.1rem;
}

.verified {
  margin: 0;
  font-size: 0.85rem;
  color: #059669; /* Green for trust */
  font-weight: 600;
}

@media (max-width: 768px) {
  .testimonials-section {
    padding: 60px 0;
  }
  .testimonial-card {
    padding: 30px;
  }
}
</style>
